export const mockups = {
    //start данные виджета
    widgetDataMockUp: {
        payload: {
            discountTickets: 0,
            countBuyTickets: 2,
            matchInfo: {
                teams: [
                    {
                        name: 'крылья советов',
                        image: './img/mockup/initMockup/wings.svg'
                    },
                    {
                        name: 'арсенал тула',
                        image: './img/mockup/initMockup/arsenal.svg'
                    }
                ],
                date: '30 ОКТ, сб, 20:00',
            },
            partners: [
                './img/mockup/initMockup/puma_logo.svg',
                './img/mockup/initMockup/solidar_logo.svg',
                './img/mockup/initMockup/sogaz_logo.svg'
            ],
            user: {
                phone_or_email: '1@1.ru',
                lastName: '',
                firstName: '',
                seatInReserve: [
                    /*  {
                          "seat": "80338",
                          "sector": "89830",
                          "price": "600.00",
                          "zoneId": "60",
                          "categoryId": "30",
                          "matchId": "3237",
                          "discount": false
                      },
                      {
                          "seat": "80374",
                          "sector": "89830",
                          "price": "300.00",
                          "zoneId": "60",
                          "categoryId": "30",
                          "matchId": "3238",
                          "discount": true
                      },
                     {
                         "seat": "80521",
                         "sector": "89830",
                         "price": "600.00",
                         "zoneId": "60",
                         "categoryId": "30",
                         "matchId": "3237",
                         "discount": false
                     },
                     {
                         "seat": "80522",
                         "sector": "89830",
                         "price": "300.00",
                         "zoneId": "60",
                         "categoryId": "30",
                         "matchId": "3239",
                         "discount": true
                     }*/
                ]
            },
            arenaId: "23",
            isPromocodesAvailable: true,
            /*subscription: {
                seatInfo: {
                   /!* seat: "80521",
                    sector: "92618",
                    zoneId: "60",
                    categoryId: "30",*!/
                },
                limit: 5,
                info: {
                    name: "Абонемент",
                    year: "2022/23",
                    img: "./img/mockup/initMockup/wings.svg"
                }
            },*/

            /* parking:[
                 {
                     id: 1,
                     parkingSector: 'd',
                     price: '400',
                     color: '#32C354',
                 },
                 {
                     id: 2,
                     parkingSector: 'c',
                     price: '600',
                     color: '#FFD300',
                 }
             ],*/
            /*services:[
                {
                    id: 1,
                    name: 'ШАРФ «ИСКУПАЕМ КУБОК В ВОЛГЕ»',
                    price: '400',
                    img: './img/mockup/orderInfo/scarf-service.png'
                },
                {
                    id: 2,
                    name: 'Бейсболка ромб синяя',
                    price: '600',
                    img: './img/mockup/orderInfo/cap-service.png'
                },
                {
                    id: 3,
                    name: 'Флаг 90*150',
                    price: '600',
                    img: './img/mockup/orderInfo/flag-service.png'
                }
            ],*/
            status: 'success',
        },
        resultCode: '200'
    },
    //end данные виджета

    //start главный экран
    //для статической разметки id = null

    chooseSectorMockUp: {
        payload: {
            authLink: 'https://ksid.internetlab.ru/login?type=match&redirectUrl=https://ks.internetlab.ru/tickets/?matchId=3313',
            "sectors": [
                {
                    "id": "34034",
                    "freePlaces": "338",
                    "minPrice": "600.00",
                    "maxPrice": "600.00"
                },
                {
                    "id": "34459",
                    "freePlaces": "440",
                    "minPrice": "600.00",
                    "maxPrice": "600.00"
                },
                {
                    "id": "5175",
                    "freePlaces": "488",
                    "minPrice": "600.00",
                    "maxPrice": "600.00"
                },
                {
                    "id": "34497",
                    "freePlaces": "113",
                    "minPrice": "600.00",
                    "maxPrice": "600.00"
                },
                {
                    "id": "82191",
                    "freePlaces": "102",
                    "minPrice": "1500.00",
                    "maxPrice": "1500.00"
                },
                {
                    "id": "34439",
                    "freePlaces": "215",
                    "minPrice": "1500.00",
                    "maxPrice": "1500.00"
                },
                {
                    "id": "3714",
                    "freePlaces": "113",
                    "minPrice": "1500.00",
                    "maxPrice": "1500.00"
                },
                {
                    "id": "83132",
                    "freePlaces": "137",
                    "minPrice": "600.00",
                    "maxPrice": "600.00"
                },
                {
                    "id": "83504",
                    "freePlaces": "402",
                    "minPrice": "600.00",
                    "maxPrice": "600.00"
                },
                {
                    "id": "84204",
                    "freePlaces": "438",
                    "minPrice": "600.00",
                    "maxPrice": "600.00"
                },
                {
                    "id": "85085",
                    "freePlaces": "438",
                    "minPrice": "389.50",
                    "maxPrice": "390.50"
                },
                {
                    "id": "85613",
                    "freePlaces": "575",
                    "minPrice": "400.00",
                    "maxPrice": "400.00"
                },
                {
                    "id": "86313",
                    "freePlaces": "565",
                    "minPrice": "400.00",
                    "maxPrice": "400.00"
                },
                {
                    "id": "87015",
                    "freePlaces": "566",
                    "minPrice": "400.00",
                    "maxPrice": "400.00"
                },
                {
                    "id": "87715",
                    "freePlaces": "440",
                    "minPrice": "400.00",
                    "maxPrice": "400.00"
                },
                {
                    "id": "88634",
                    "freePlaces": "433",
                    "minPrice": "400.00",
                    "maxPrice": "400.00"
                },
                {
                    "id": "89130",
                    "freePlaces": "562",
                    "minPrice": "400.00",
                    "maxPrice": "400.00"
                },
                {
                    "id": "89830",
                    "freePlaces": "375",
                    "minPrice": "500.00",
                    "maxPrice": "500.00"
                },
                {
                    "id": "90530",
                    "freePlaces": "81",
                    "minPrice": "500.00",
                    "maxPrice": "500.00"
                },
                {
                    "id": "91218",
                    "freePlaces": "398",
                    "minPrice": "500.00",
                    "maxPrice": "500.00"
                },
                {
                    "id": "91918",
                    "freePlaces": "280",
                    "minPrice": "400.00",
                    "maxPrice": "400.00"
                },
                {
                    "id": "92618",
                    "freePlaces": "433",
                    "minPrice": "400.00",
                    "maxPrice": "400.00"
                },
                {
                    "id": "93111",
                    "freePlaces": "329",
                    "minPrice": 0,
                    "maxPrice": 0
                },
                {
                    "id": "93504",
                    "freePlaces": "447",
                    "minPrice": "400.00",
                    "maxPrice": "400.00"
                },
                {
                    "id": "122188",
                    "freePlaces": "4",
                    "minPrice": "400.00",
                    "maxPrice": "400.00"
                },
                {
                    "id": "27124",
                    "freePlaces": "594",
                    "minPrice": "400.00",
                    "maxPrice": "400.00"
                },
                {
                    "id": "15780",
                    "freePlaces": "590",
                    "minPrice": "400.00",
                    "maxPrice": "400.00"
                },
                {
                    "id": "33012",
                    "freePlaces": "593",
                    "minPrice": "400.00",
                    "maxPrice": "400.00"
                },
                {
                    "id": "96133",
                    "freePlaces": "432",
                    "minPrice": "400.00",
                    "maxPrice": "400.00"
                },
                {
                    "id": "98921",
                    "freePlaces": "93",
                    "minPrice": "1000.00",
                    "maxPrice": "1000.00"
                },
                {
                    "id": "99020",
                    "freePlaces": "12",
                    "minPrice": "1000.00",
                    "maxPrice": "1000.00"
                },
                {
                    "id": "99039",
                    "freePlaces": "62",
                    "minPrice": "1000.00",
                    "maxPrice": "1000.00"
                },
                {
                    "id": "99106",
                    "freePlaces": "67",
                    "minPrice": "1000.00",
                    "maxPrice": "1000.00"
                },
                {
                    "id": "99191",
                    "freePlaces": "17",
                    "minPrice": "1000.00",
                    "maxPrice": "1000.00"
                },
                {
                    "id": "99223",
                    "freePlaces": "62",
                    "minPrice": "1000.00",
                    "maxPrice": "1000.00"
                },
                {
                    "id": "99308",
                    "freePlaces": "57",
                    "minPrice": "1000.00",
                    "maxPrice": "1000.00"
                },
                {
                    "id": "99986",
                    "freePlaces": "103",
                    "minPrice": "1000.00",
                    "maxPrice": "1000.00"
                },
                {
                    "id": "100140",
                    "freePlaces": "146",
                    "minPrice": "1000.00",
                    "maxPrice": "1000.00"
                },
                {
                    "id": "100291",
                    "freePlaces": "69",
                    "minPrice": "1000.00",
                    "maxPrice": "1000.00"
                },
                {
                    "id": "100381",
                    "freePlaces": "148",
                    "minPrice": "1000.00",
                    "maxPrice": "1000.00"
                },
                {
                    "id": "19846",
                    "freePlaces": "148",
                    "minPrice": "1000.00",
                    "maxPrice": "1000.00"
                },
                {
                    "id": "98155",
                    "freePlaces": "148",
                    "minPrice": "1000.00",
                    "maxPrice": "1000.00"
                }
            ],
            status: 'success',
            /*statusCode: '20124'*/
        },
        resultCode: '200'
    },
    //end главный экран

    //start выбор места
    placeSelectMockup: {
        "payload": {
            "places": [
                {
                    "id": "80202",
                    "isAvailable": false,
                    "row": "4",
                    "seat": "1",
                    "x": "15",
                    "y": "1"
                },
                {
                    "id": "80203",
                    "isAvailable": false,
                    "row": "4",
                    "seat": "2",
                    "x": "30",
                    "y": "1"
                },
                {
                    "id": "80205",
                    "isAvailable": false,
                    "row": "5",
                    "seat": "1",
                    "x": "15",
                    "y": "2"
                },
                {
                    "id": "80206",
                    "isAvailable": false,
                    "row": "5",
                    "seat": "2",
                    "x": "30",
                    "y": "2"
                },
                {
                    "id": "80208",
                    "isAvailable": true,
                    "row": "6",
                    "seat": "1",
                    "x": "15",
                    "y": "3",
                    "price": "600.30",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80209",
                    "isAvailable": true,
                    "row": "6",
                    "seat": "2",
                    "x": "16",
                    "y": "3",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80210",
                    "isAvailable": true,
                    "row": "6",
                    "seat": "3",
                    "x": "29",
                    "y": "3",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80211",
                    "isAvailable": true,
                    "row": "6",
                    "seat": "4",
                    "x": "30",
                    "y": "3",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80213",
                    "isAvailable": true,
                    "row": "7",
                    "seat": "1",
                    "x": "14",
                    "y": "4",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80214",
                    "isAvailable": true,
                    "row": "7",
                    "seat": "2",
                    "x": "15",
                    "y": "4",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80215",
                    "isAvailable": true,
                    "row": "7",
                    "seat": "3",
                    "x": "16",
                    "y": "4",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80216",
                    "isAvailable": true,
                    "row": "7",
                    "seat": "4",
                    "x": "29",
                    "y": "4",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80217",
                    "isAvailable": true,
                    "row": "7",
                    "seat": "5",
                    "x": "30",
                    "y": "4",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80218",
                    "isAvailable": true,
                    "row": "7",
                    "seat": "6",
                    "x": "31",
                    "y": "4",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80220",
                    "isAvailable": true,
                    "row": "8",
                    "seat": "1",
                    "x": "13",
                    "y": "5",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80221",
                    "isAvailable": true,
                    "row": "8",
                    "seat": "2",
                    "x": "14",
                    "y": "5",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80222",
                    "isAvailable": true,
                    "row": "8",
                    "seat": "3",
                    "x": "15",
                    "y": "5",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80223",
                    "isAvailable": true,
                    "row": "8",
                    "seat": "4",
                    "x": "16",
                    "y": "5",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80224",
                    "isAvailable": true,
                    "row": "8",
                    "seat": "5",
                    "x": "29",
                    "y": "5",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80225",
                    "isAvailable": true,
                    "row": "8",
                    "seat": "6",
                    "x": "30",
                    "y": "5",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80226",
                    "isAvailable": true,
                    "row": "8",
                    "seat": "7",
                    "x": "31",
                    "y": "5",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80227",
                    "isAvailable": true,
                    "row": "8",
                    "seat": "8",
                    "x": "32",
                    "y": "5",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80229",
                    "isAvailable": true,
                    "row": "9",
                    "seat": "1",
                    "x": "12",
                    "y": "6",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80230",
                    "isAvailable": true,
                    "row": "9",
                    "seat": "2",
                    "x": "13",
                    "y": "6",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80231",
                    "isAvailable": true,
                    "row": "9",
                    "seat": "3",
                    "x": "14",
                    "y": "6",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80232",
                    "isAvailable": true,
                    "row": "9",
                    "seat": "4",
                    "x": "15",
                    "y": "6",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80233",
                    "isAvailable": true,
                    "row": "9",
                    "seat": "5",
                    "x": "16",
                    "y": "6",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80234",
                    "isAvailable": true,
                    "row": "9",
                    "seat": "6",
                    "x": "29",
                    "y": "6",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80235",
                    "isAvailable": true,
                    "row": "9",
                    "seat": "7",
                    "x": "30",
                    "y": "6",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80236",
                    "isAvailable": true,
                    "row": "9",
                    "seat": "8",
                    "x": "31",
                    "y": "6",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80237",
                    "isAvailable": true,
                    "row": "9",
                    "seat": "9",
                    "x": "32",
                    "y": "6",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80238",
                    "isAvailable": true,
                    "row": "9",
                    "seat": "10",
                    "x": "33",
                    "y": "6",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80240",
                    "isAvailable": true,
                    "row": "10",
                    "seat": "1",
                    "x": "11",
                    "y": "7",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80241",
                    "isAvailable": true,
                    "row": "10",
                    "seat": "2",
                    "x": "12",
                    "y": "7",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80242",
                    "isAvailable": true,
                    "row": "10",
                    "seat": "3",
                    "x": "13",
                    "y": "7",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80243",
                    "isAvailable": true,
                    "row": "10",
                    "seat": "4",
                    "x": "14",
                    "y": "7",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80244",
                    "isAvailable": true,
                    "row": "10",
                    "seat": "5",
                    "x": "15",
                    "y": "7",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80245",
                    "isAvailable": true,
                    "row": "10",
                    "seat": "6",
                    "x": "16",
                    "y": "7",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80246",
                    "isAvailable": true,
                    "row": "10",
                    "seat": "7",
                    "x": "29",
                    "y": "7",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80247",
                    "isAvailable": true,
                    "row": "10",
                    "seat": "8",
                    "x": "30",
                    "y": "7",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80248",
                    "isAvailable": true,
                    "row": "10",
                    "seat": "9",
                    "x": "31",
                    "y": "7",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80249",
                    "isAvailable": true,
                    "row": "10",
                    "seat": "10",
                    "x": "32",
                    "y": "7",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80250",
                    "isAvailable": true,
                    "row": "10",
                    "seat": "11",
                    "x": "33",
                    "y": "7",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80251",
                    "isAvailable": true,
                    "row": "10",
                    "seat": "12",
                    "x": "34",
                    "y": "7",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80253",
                    "isAvailable": true,
                    "row": "11",
                    "seat": "1",
                    "x": "10",
                    "y": "8",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80254",
                    "isAvailable": true,
                    "row": "11",
                    "seat": "2",
                    "x": "11",
                    "y": "8",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80255",
                    "isAvailable": true,
                    "row": "11",
                    "seat": "3",
                    "x": "12",
                    "y": "8",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80256",
                    "isAvailable": true,
                    "row": "11",
                    "seat": "4",
                    "x": "13",
                    "y": "8",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80257",
                    "isAvailable": true,
                    "row": "11",
                    "seat": "5",
                    "x": "14",
                    "y": "8",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80258",
                    "isAvailable": true,
                    "row": "11",
                    "seat": "6",
                    "x": "15",
                    "y": "8",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80259",
                    "isAvailable": true,
                    "row": "11",
                    "seat": "7",
                    "x": "16",
                    "y": "8",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80260",
                    "isAvailable": true,
                    "row": "11",
                    "seat": "8",
                    "x": "29",
                    "y": "8",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80261",
                    "isAvailable": true,
                    "row": "11",
                    "seat": "9",
                    "x": "30",
                    "y": "8",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80262",
                    "isAvailable": true,
                    "row": "11",
                    "seat": "10",
                    "x": "31",
                    "y": "8",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80263",
                    "isAvailable": true,
                    "row": "11",
                    "seat": "11",
                    "x": "32",
                    "y": "8",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80264",
                    "isAvailable": true,
                    "row": "11",
                    "seat": "12",
                    "x": "33",
                    "y": "8",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80265",
                    "isAvailable": true,
                    "row": "11",
                    "seat": "13",
                    "x": "34",
                    "y": "8",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80266",
                    "isAvailable": true,
                    "row": "11",
                    "seat": "14",
                    "x": "35",
                    "y": "8",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80268",
                    "isAvailable": true,
                    "row": "12",
                    "seat": "1",
                    "x": "9",
                    "y": "9",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80269",
                    "isAvailable": true,
                    "row": "12",
                    "seat": "2",
                    "x": "10",
                    "y": "9",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80270",
                    "isAvailable": true,
                    "row": "12",
                    "seat": "3",
                    "x": "11",
                    "y": "9",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80271",
                    "isAvailable": true,
                    "row": "12",
                    "seat": "4",
                    "x": "12",
                    "y": "9",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80272",
                    "isAvailable": true,
                    "row": "12",
                    "seat": "5",
                    "x": "13",
                    "y": "9",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80273",
                    "isAvailable": true,
                    "row": "12",
                    "seat": "6",
                    "x": "14",
                    "y": "9",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80274",
                    "isAvailable": true,
                    "row": "12",
                    "seat": "7",
                    "x": "15",
                    "y": "9",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80275",
                    "isAvailable": true,
                    "row": "12",
                    "seat": "8",
                    "x": "16",
                    "y": "9",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80276",
                    "isAvailable": true,
                    "row": "12",
                    "seat": "9",
                    "x": "29",
                    "y": "9",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80277",
                    "isAvailable": true,
                    "row": "12",
                    "seat": "10",
                    "x": "30",
                    "y": "9",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80278",
                    "isAvailable": true,
                    "row": "12",
                    "seat": "11",
                    "x": "31",
                    "y": "9",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80279",
                    "isAvailable": true,
                    "row": "12",
                    "seat": "12",
                    "x": "32",
                    "y": "9",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80280",
                    "isAvailable": true,
                    "row": "12",
                    "seat": "13",
                    "x": "33",
                    "y": "9",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80281",
                    "isAvailable": true,
                    "row": "12",
                    "seat": "14",
                    "x": "34",
                    "y": "9",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80282",
                    "isAvailable": true,
                    "row": "12",
                    "seat": "15",
                    "x": "35",
                    "y": "9",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80283",
                    "isAvailable": true,
                    "row": "12",
                    "seat": "16",
                    "x": "36",
                    "y": "9",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80285",
                    "isAvailable": true,
                    "row": "13",
                    "seat": "1",
                    "x": "8",
                    "y": "10",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80286",
                    "isAvailable": true,
                    "row": "13",
                    "seat": "2",
                    "x": "9",
                    "y": "10",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80287",
                    "isAvailable": true,
                    "row": "13",
                    "seat": "3",
                    "x": "10",
                    "y": "10",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80288",
                    "isAvailable": true,
                    "row": "13",
                    "seat": "4",
                    "x": "11",
                    "y": "10",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80289",
                    "isAvailable": true,
                    "row": "13",
                    "seat": "5",
                    "x": "12",
                    "y": "10",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80290",
                    "isAvailable": true,
                    "row": "13",
                    "seat": "6",
                    "x": "13",
                    "y": "10",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80291",
                    "isAvailable": true,
                    "row": "13",
                    "seat": "7",
                    "x": "14",
                    "y": "10",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80292",
                    "isAvailable": false,
                    "row": "13",
                    "seat": "8",
                    "x": "15",
                    "y": "10"
                },
                {
                    "id": "80293",
                    "isAvailable": true,
                    "row": "13",
                    "seat": "9",
                    "x": "16",
                    "y": "10",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80294",
                    "isAvailable": true,
                    "row": "13",
                    "seat": "10",
                    "x": "29",
                    "y": "10",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80295",
                    "isAvailable": true,
                    "row": "13",
                    "seat": "11",
                    "x": "30",
                    "y": "10",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80296",
                    "isAvailable": true,
                    "row": "13",
                    "seat": "12",
                    "x": "31",
                    "y": "10",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80297",
                    "isAvailable": true,
                    "row": "13",
                    "seat": "13",
                    "x": "32",
                    "y": "10",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80298",
                    "isAvailable": true,
                    "row": "13",
                    "seat": "14",
                    "x": "33",
                    "y": "10",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80299",
                    "isAvailable": true,
                    "row": "13",
                    "seat": "15",
                    "x": "34",
                    "y": "10",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80300",
                    "isAvailable": true,
                    "row": "13",
                    "seat": "16",
                    "x": "35",
                    "y": "10",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80301",
                    "isAvailable": true,
                    "row": "13",
                    "seat": "17",
                    "x": "36",
                    "y": "10",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80302",
                    "isAvailable": true,
                    "row": "13",
                    "seat": "18",
                    "x": "37",
                    "y": "10",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80304",
                    "isAvailable": true,
                    "row": "14",
                    "seat": "1",
                    "x": "7",
                    "y": "11",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80305",
                    "isAvailable": true,
                    "row": "14",
                    "seat": "2",
                    "x": "8",
                    "y": "11",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80306",
                    "isAvailable": true,
                    "row": "14",
                    "seat": "3",
                    "x": "9",
                    "y": "11",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80307",
                    "isAvailable": true,
                    "row": "14",
                    "seat": "4",
                    "x": "10",
                    "y": "11",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80308",
                    "isAvailable": true,
                    "row": "14",
                    "seat": "5",
                    "x": "11",
                    "y": "11",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80309",
                    "isAvailable": true,
                    "row": "14",
                    "seat": "6",
                    "x": "12",
                    "y": "11",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80310",
                    "isAvailable": true,
                    "row": "14",
                    "seat": "7",
                    "x": "13",
                    "y": "11",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80311",
                    "isAvailable": true,
                    "row": "14",
                    "seat": "8",
                    "x": "14",
                    "y": "11",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80312",
                    "isAvailable": true,
                    "row": "14",
                    "seat": "9",
                    "x": "15",
                    "y": "11",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80313",
                    "isAvailable": true,
                    "row": "14",
                    "seat": "10",
                    "x": "16",
                    "y": "11",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80314",
                    "isAvailable": true,
                    "row": "14",
                    "seat": "11",
                    "x": "29",
                    "y": "11",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80315",
                    "isAvailable": true,
                    "row": "14",
                    "seat": "12",
                    "x": "30",
                    "y": "11",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80316",
                    "isAvailable": true,
                    "row": "14",
                    "seat": "13",
                    "x": "31",
                    "y": "11",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80317",
                    "isAvailable": true,
                    "row": "14",
                    "seat": "14",
                    "x": "32",
                    "y": "11",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80318",
                    "isAvailable": true,
                    "row": "14",
                    "seat": "15",
                    "x": "33",
                    "y": "11",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80319",
                    "isAvailable": true,
                    "row": "14",
                    "seat": "16",
                    "x": "34",
                    "y": "11",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80320",
                    "isAvailable": true,
                    "row": "14",
                    "seat": "17",
                    "x": "35",
                    "y": "11",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80321",
                    "isAvailable": true,
                    "row": "14",
                    "seat": "18",
                    "x": "36",
                    "y": "11",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80322",
                    "isAvailable": true,
                    "row": "14",
                    "seat": "19",
                    "x": "37",
                    "y": "11",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80323",
                    "isAvailable": true,
                    "row": "14",
                    "seat": "20",
                    "x": "38",
                    "y": "11",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80325",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "1",
                    "x": "6",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80326",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "2",
                    "x": "7",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80327",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "3",
                    "x": "8",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80328",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "4",
                    "x": "9",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80329",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "5",
                    "x": "10",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80330",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "6",
                    "x": "11",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80331",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "7",
                    "x": "12",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80332",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "8",
                    "x": "13",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80333",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "9",
                    "x": "14",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80334",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "10",
                    "x": "15",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80335",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "11",
                    "x": "16",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80336",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "12",
                    "x": "17",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80337",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "13",
                    "x": "18",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80338",
                    "isAvailable": false,
                    "row": "15",
                    "seat": "14",
                    "x": "19",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80339",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "15",
                    "x": "20",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80340",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "16",
                    "x": "21",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80341",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "17",
                    "x": "22",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80342",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "18",
                    "x": "23",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80343",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "19",
                    "x": "24",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80344",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "20",
                    "x": "25",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80345",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "21",
                    "x": "26",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80346",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "22",
                    "x": "27",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80347",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "23",
                    "x": "28",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80348",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "24",
                    "x": "29",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80349",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "25",
                    "x": "30",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80350",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "26",
                    "x": "31",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80351",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "27",
                    "x": "32",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80352",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "28",
                    "x": "33",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80353",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "29",
                    "x": "34",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80354",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "30",
                    "x": "35",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80355",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "31",
                    "x": "36",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80356",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "32",
                    "x": "37",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80357",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "33",
                    "x": "38",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80358",
                    "isAvailable": true,
                    "row": "15",
                    "seat": "34",
                    "x": "39",
                    "y": "12",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80360",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "1",
                    "x": "5",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80361",
                    "isAvailable": false,
                    "row": "16",
                    "seat": "2",
                    "x": "6",
                    "y": "13"
                },
                {
                    "id": "80362",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "3",
                    "x": "7",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80363",
                    "isAvailable": false,
                    "row": "16",
                    "seat": "4",
                    "x": "8",
                    "y": "13"
                },
                {
                    "id": "80364",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "5",
                    "x": "9",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80365",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "6",
                    "x": "10",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80366",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "7",
                    "x": "11",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80367",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "8",
                    "x": "12",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80368",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "9",
                    "x": "13",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80369",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "10",
                    "x": "14",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80370",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "11",
                    "x": "15",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80371",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "12",
                    "x": "16",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80372",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "13",
                    "x": "17",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80373",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "14",
                    "x": "18",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80374",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "15",
                    "x": "19",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80375",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "16",
                    "x": "20",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80376",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "17",
                    "x": "21",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80377",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "18",
                    "x": "22",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80378",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "19",
                    "x": "23",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80379",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "20",
                    "x": "24",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80380",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "21",
                    "x": "25",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80381",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "22",
                    "x": "26",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80382",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "23",
                    "x": "27",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80383",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "24",
                    "x": "28",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80384",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "25",
                    "x": "29",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80385",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "26",
                    "x": "30",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80386",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "27",
                    "x": "31",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80387",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "28",
                    "x": "32",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80388",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "29",
                    "x": "33",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80389",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "30",
                    "x": "34",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80390",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "31",
                    "x": "35",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80391",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "32",
                    "x": "36",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80392",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "33",
                    "x": "37",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80393",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "34",
                    "x": "38",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80394",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "35",
                    "x": "39",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80395",
                    "isAvailable": true,
                    "row": "16",
                    "seat": "36",
                    "x": "40",
                    "y": "13",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80397",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "1",
                    "x": "4",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80398",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "2",
                    "x": "5",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80399",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "3",
                    "x": "6",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80400",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "4",
                    "x": "7",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80401",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "5",
                    "x": "8",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80402",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "6",
                    "x": "9",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80403",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "7",
                    "x": "10",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80404",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "8",
                    "x": "11",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80405",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "9",
                    "x": "12",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80406",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "10",
                    "x": "13",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80407",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "11",
                    "x": "14",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80408",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "12",
                    "x": "15",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80409",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "13",
                    "x": "16",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80410",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "14",
                    "x": "17",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80411",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "15",
                    "x": "18",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80412",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "16",
                    "x": "19",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80413",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "17",
                    "x": "20",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80414",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "18",
                    "x": "21",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80415",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "19",
                    "x": "22",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80416",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "20",
                    "x": "23",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80417",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "21",
                    "x": "24",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80418",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "22",
                    "x": "25",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80419",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "23",
                    "x": "26",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80420",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "24",
                    "x": "27",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80421",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "25",
                    "x": "28",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80422",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "26",
                    "x": "29",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80423",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "27",
                    "x": "30",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80424",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "28",
                    "x": "31",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80425",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "29",
                    "x": "32",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80426",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "30",
                    "x": "33",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80427",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "31",
                    "x": "34",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80428",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "32",
                    "x": "35",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80429",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "33",
                    "x": "36",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80430",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "34",
                    "x": "37",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80431",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "35",
                    "x": "38",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80432",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "36",
                    "x": "39",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80433",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "37",
                    "x": "40",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80434",
                    "isAvailable": true,
                    "row": "17",
                    "seat": "38",
                    "x": "41",
                    "y": "14",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80436",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "1",
                    "x": "3",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80437",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "2",
                    "x": "4",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80438",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "3",
                    "x": "5",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80439",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "4",
                    "x": "6",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80440",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "5",
                    "x": "7",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80441",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "6",
                    "x": "8",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80442",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "7",
                    "x": "9",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80443",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "8",
                    "x": "10",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80444",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "9",
                    "x": "11",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80445",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "10",
                    "x": "12",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80446",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "11",
                    "x": "13",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80447",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "12",
                    "x": "14",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80448",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "13",
                    "x": "15",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80449",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "14",
                    "x": "16",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80450",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "15",
                    "x": "17",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80451",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "16",
                    "x": "18",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80452",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "17",
                    "x": "19",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80453",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "18",
                    "x": "20",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80454",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "19",
                    "x": "21",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80455",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "20",
                    "x": "22",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80456",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "21",
                    "x": "23",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80457",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "22",
                    "x": "24",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80458",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "23",
                    "x": "25",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80459",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "24",
                    "x": "26",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80460",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "25",
                    "x": "27",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80461",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "26",
                    "x": "28",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80462",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "27",
                    "x": "29",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80463",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "28",
                    "x": "30",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80464",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "29",
                    "x": "31",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80465",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "30",
                    "x": "32",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80466",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "31",
                    "x": "33",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80467",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "32",
                    "x": "34",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80468",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "33",
                    "x": "35",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80469",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "34",
                    "x": "36",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80470",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "35",
                    "x": "37",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80471",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "36",
                    "x": "38",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80472",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "37",
                    "x": "39",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80473",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "38",
                    "x": "40",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80474",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "39",
                    "x": "41",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80475",
                    "isAvailable": true,
                    "row": "18",
                    "seat": "40",
                    "x": "42",
                    "y": "15",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80477",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "1",
                    "x": "2",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80478",
                    "isAvailable": false,
                    "row": "19",
                    "seat": "2",
                    "x": "3",
                    "y": "16"
                },
                {
                    "id": "80479",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "3",
                    "x": "4",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80480",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "4",
                    "x": "5",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80481",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "5",
                    "x": "6",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80482",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "6",
                    "x": "7",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80483",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "7",
                    "x": "8",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80484",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "8",
                    "x": "9",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80485",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "9",
                    "x": "10",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80486",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "10",
                    "x": "11",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80487",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "11",
                    "x": "12",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80488",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "12",
                    "x": "13",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80489",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "13",
                    "x": "14",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80490",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "14",
                    "x": "15",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80491",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "15",
                    "x": "16",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80492",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "16",
                    "x": "17",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80493",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "17",
                    "x": "18",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80494",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "18",
                    "x": "19",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80495",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "19",
                    "x": "20",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80496",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "20",
                    "x": "21",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80497",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "21",
                    "x": "22",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80498",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "22",
                    "x": "23",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80499",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "23",
                    "x": "24",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80500",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "24",
                    "x": "25",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80501",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "25",
                    "x": "26",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80502",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "26",
                    "x": "27",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80503",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "27",
                    "x": "28",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80504",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "28",
                    "x": "29",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80505",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "29",
                    "x": "30",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80506",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "30",
                    "x": "31",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80507",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "31",
                    "x": "32",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80508",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "32",
                    "x": "33",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80509",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "33",
                    "x": "34",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80510",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "34",
                    "x": "35",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80511",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "35",
                    "x": "36",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80512",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "36",
                    "x": "37",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80513",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "37",
                    "x": "38",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80514",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "38",
                    "x": "39",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80515",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "39",
                    "x": "40",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80516",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "40",
                    "x": "41",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80517",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "41",
                    "x": "42",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80518",
                    "isAvailable": true,
                    "row": "19",
                    "seat": "42",
                    "x": "43",
                    "y": "16",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80520",
                    "isAvailable": false,
                    "row": "20",
                    "seat": "1",
                    "x": "1",
                    "y": "17"
                },
                {
                    "id": "80521",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "2",
                    "x": "2",
                    "y": "17",
                    "price": "600.10",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80522",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "3",
                    "x": "3",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80523",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "4",
                    "x": "4",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80524",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "5",
                    "x": "5",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80525",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "6",
                    "x": "6",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80526",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "7",
                    "x": "7",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80527",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "8",
                    "x": "8",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80528",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "9",
                    "x": "9",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80529",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "10",
                    "x": "10",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80530",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "11",
                    "x": "11",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80531",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "12",
                    "x": "12",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80532",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "13",
                    "x": "13",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80533",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "14",
                    "x": "14",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80534",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "15",
                    "x": "15",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80535",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "16",
                    "x": "16",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80536",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "17",
                    "x": "17",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80537",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "18",
                    "x": "18",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80538",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "19",
                    "x": "19",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80539",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "20",
                    "x": "20",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80540",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "21",
                    "x": "21",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80541",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "22",
                    "x": "22",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80542",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "23",
                    "x": "23",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80543",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "24",
                    "x": "24",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80544",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "25",
                    "x": "25",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80545",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "26",
                    "x": "26",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80546",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "27",
                    "x": "27",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80547",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "28",
                    "x": "28",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80548",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "29",
                    "x": "29",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80549",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "30",
                    "x": "30",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80550",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "31",
                    "x": "31",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80551",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "32",
                    "x": "32",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80552",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "33",
                    "x": "33",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80553",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "34",
                    "x": "34",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80554",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "35",
                    "x": "35",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80555",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "36",
                    "x": "36",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80556",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "37",
                    "x": "37",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80557",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "38",
                    "x": "38",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80558",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "39",
                    "x": "39",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80559",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "40",
                    "x": "40",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80560",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "41",
                    "x": "41",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80561",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "42",
                    "x": "42",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80562",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "43",
                    "x": "43",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80563",
                    "isAvailable": true,
                    "row": "20",
                    "seat": "44",
                    "x": "44",
                    "y": "17",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30"
                },
                {
                    "id": "80565",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "1",
                    "x": "1",
                    "y": "18"
                },
                {
                    "id": "80566",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "2",
                    "x": "3",
                    "y": "18"
                },
                {
                    "id": "80567",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "3",
                    "x": "4",
                    "y": "18"
                },
                {
                    "id": "80568",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "4",
                    "x": "5",
                    "y": "18"
                },
                {
                    "id": "80569",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "5",
                    "x": "6",
                    "y": "18"
                },
                {
                    "id": "80570",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "6",
                    "x": "7",
                    "y": "18"
                },
                {
                    "id": "80571",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "7",
                    "x": "8",
                    "y": "18"
                },
                {
                    "id": "80572",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "8",
                    "x": "9",
                    "y": "18"
                },
                {
                    "id": "80573",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "9",
                    "x": "10",
                    "y": "18"
                },
                {
                    "id": "80574",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "10",
                    "x": "11",
                    "y": "18"
                },
                {
                    "id": "80575",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "11",
                    "x": "12",
                    "y": "18"
                },
                {
                    "id": "80576",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "12",
                    "x": "13",
                    "y": "18"
                },
                {
                    "id": "80577",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "13",
                    "x": "14",
                    "y": "18"
                },
                {
                    "id": "80578",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "14",
                    "x": "15",
                    "y": "18"
                },
                {
                    "id": "80579",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "15",
                    "x": "16",
                    "y": "18"
                },
                {
                    "id": "80580",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "16",
                    "x": "17",
                    "y": "18"
                },
                {
                    "id": "80581",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "17",
                    "x": "18",
                    "y": "18"
                },
                {
                    "id": "80582",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "18",
                    "x": "19",
                    "y": "18"
                },
                {
                    "id": "80583",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "19",
                    "x": "20",
                    "y": "18"
                },
                {
                    "id": "80584",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "20",
                    "x": "21",
                    "y": "18"
                },
                {
                    "id": "80585",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "21",
                    "x": "22",
                    "y": "18"
                },
                {
                    "id": "80586",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "22",
                    "x": "23",
                    "y": "18"
                },
                {
                    "id": "80587",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "23",
                    "x": "24",
                    "y": "18"
                },
                {
                    "id": "80588",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "24",
                    "x": "25",
                    "y": "18"
                },
                {
                    "id": "80589",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "25",
                    "x": "26",
                    "y": "18"
                },
                {
                    "id": "80590",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "26",
                    "x": "27",
                    "y": "18"
                },
                {
                    "id": "80591",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "27",
                    "x": "28",
                    "y": "18"
                },
                {
                    "id": "80592",
                    "isAvailable": false,
                    "row": "21",
                    "seat": "28",
                    "x": "29",
                    "y": "18"
                },
                {
                    "id": "228228",
                    "isAvailable": true,
                    "row": "21",
                    "seat": "28",
                    "x": "29",
                    "y": "18"
                }
            ],
            "settings": {
                "yMax": "18",
                "xMax": "44"
            },
            "status": "success"
        },
        "resultCode": "200"
    },
    //end выбор места

    //start ваш заказ
    /*  orderInfo: {
          payload: {
              serviceProducts: [
                  {
                      serviceId: '1',
                      image: './img/mockup/orderInfo/parking-service.svg',
                      name: 'Платный паркинг у стадиона',
                      startPrice: '600',
                      variants: [
                          {
                              variantName: 'b',
                              variantColor: '#32C354',
                              price: '600'
                          },
                          {
                              variantName: 'd',
                              variantColor: '#FFD300',
                              price: '700'
                          }
                      ]
                  },
                  {
                      serviceId: '2',
                      image: './img/mockup/orderInfo/cap-service.png',
                      name: 'Бейсболка ромб синяя',
                      startPrice: '800'
                  },
                  {
                      serviceId: '3',
                      image: './img/mockup/orderInfo/scarf-service.png',
                      name: 'ШАРФ «ИСКУПАЕМ КУБОК В ВОЛГЕ»',
                      startPrice: '1000'
                  },
                  {
                      serviceId: '4',
                      image: './img/mockup/orderInfo/flag-service.png',
                      name: 'Флаг 90*150',
                      startPrice: '1200'
                  }
              ]
          },
          status: '200'
      },*/

    //отправка пароля на почту/телефон
    sendPassword: [],

    //проверка пароля
    checkPassword: {
        "status": "success", // "expired" - код истек, "incorrect" - код некорректный
        "completedProfile": true // false флаг заполненности профиля
    },

    //получение профиля пользователя
    getUserProfile: {
        "id": "7",
        "username": null,
        "name": null,
        "lastname": null,
        "dateBirthday": null,
        "phone": null,
        "email": "topice4@gmail.com",
        "city": null,
        "address": null,
        "sex": null
    },

    //создание заказа и редирект на оплату в сбере
    createOrder: {
        "payload": {
            "status": "error",
            "link": "https://link-to-sber",
            "orderId": "140983",
        },
        "resultCode": "200"
    },

    //получение статуса оплаты
    sendPaymentStatus: {
        "payload": {
            "status": "success",
            "barcode": ["4823573945"],
            "orderId": "140983"
        },
        "resultCode": "200"
    },

    //отправка билетов на почту
    sendTicketOnEmail: {
        "payload": {
            "status": "success"
        },
        "resultCode": "200"
    },
    //получение бонусов
    getBonuses:
        {
            "status": "OK",
            "payload": {
                "count": 7743,
                "maxWriteOff": 300,
                "maxAccrue": 504,
                "bonusLevel": {
                    "id": 1,
                    "name": "Зелёный",
                    "sumFrom": 0,
                    "percentAddTicket": 15,
                    "percentSubTicket": 20,
                    "percentAddShop": 10,
                    "percentSubShop": 15,
                    "apiCode": "standard"
                },
                "promoCode": {
                    "discount_type": "percent",
                    "discount_value": 10,
                    "message": "Обращаем ваше внимание, что далее содержится очень длинный текст по списанию >30%, чего категорически делать нельзя, поэтому спишем вам намного меньше, чем вы хотели"
                },
                "products": [
                    {
                        "id": 59,
                        "priceFull": 4690,
                        "price": 4690,
                        "count": 1,
                        "application": "store",
                        "writeOff": {
                            "price": 3987,
                            "bonus": 703
                        },
                        "accrue": {
                            "price": 4690,
                            "bonus": 469
                        }
                    },
                    {
                        "id": 191,
                        "priceFull": 390,
                        "price": 351,
                        "count": 2,
                        "application": "store",
                        "writeOff": {
                            "price": 299,
                            "bonus": 52
                        },
                        "accrue": {
                            "price": 351,
                            "bonus": 35
                        }
                    }
                ],
                "amountPay": {
                    "writeOff": 540,
                    "accrue": 540,
                    "fullPrice":600
                }
            }
        }
    ,

    //fanid
    fanId: {
        "payload": {
            /*"ResultCode": "20115",*/
            "status": "success"
        },
        "resultCode": "200"
    },

    //удаление брони (доп данные для проверки удаления : если бронируем на >1 вкладке
    // и в ответе есть ещё забронированные места) -> до запрос на удаление брони
    deleteBooking: {
        "payload": {
            "status": "success",
            seatInReserve: [
                /*{
                    "seat": "80338",
                    "sector": "89830",
                    "price": "600.00",
                    "zoneId": "60",
                    "categoryId": "30",
                    "matchId": "3237",
                    "discount": false
                },
                {
                    "seat": "80374",
                    "sector": "89830",
                    "price": "300.00",
                    "zoneId": "60",
                    "categoryId": "30",
                    "matchId": "3238",
                    "discount": true
                }*/
            ]
        },
        "resultCode": "200"
    },
    //промокод
    validatePromocode:{
        success:{
            payload: {
                promocode:{
                    discount_value: 10,
                    discount_type: '%',
                    min_value: 500
                },
                status: "success"
            },
            resultCode: "200"
        },
        error:{
            payload: {
                status: "error",
                errorText: "Срок действия промокода истек Срок действия промокода истек"
            },
            resultCode: "200"
        }
    }
}